module.exports = __webpack_public_path__ + "static/media/1024x768_confirmation_image.3ceea071.png";